__turbopack_context__.v({
  "group": "list-module__bgYH0a__group",
  "groupItems": "list-module__bgYH0a__groupItems",
  "groupTitle": "list-module__bgYH0a__groupTitle",
  "list": "list-module__bgYH0a__list",
  "vertical": "list-module__bgYH0a__vertical",
  "virtual": "list-module__bgYH0a__virtual",
});
